import script from "./ExperienceForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ExperienceForm.vue?vue&type=script&setup=true&lang=js"

import "./ExperienceForm.vue?vue&type=style&index=0&id=219a4ee4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-219a4ee4"]])

export default __exports__